import { useKeyIndicatorTags } from "react-migration/lib/map/useKeyIndicatorTags";
import { Belts } from "./types";
import { getGreenBeltIndicator } from "./getGreenBeltIndicator";

export const useGreenGreyBeltInsights = (belt: Belts | null) => {
  useKeyIndicatorTags(() => {
    return getGreenBeltIndicator(belt);
  }, [belt]);
};
